import { ApplicationConfig, isDevMode } from '@angular/core';
import { provideRouter, Router } from '@angular/router';
import { provideHttpClient } from '@angular/common/http';
import { provideServiceWorker } from '@angular/service-worker';
import { Apollo, APOLLO_OPTIONS } from 'apollo-angular';
import { HttpLink } from 'apollo-angular/http';
import { ApolloLink, InMemoryCache } from '@apollo/client/core';
import { onError } from '@apollo/client/link/error';
import { routes } from './app.routes';
import { environment } from '../environments/environment';
import { lerToken } from './core/auth.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideHttpClient(),
    Apollo,
    {
      provide: APOLLO_OPTIONS,
      useFactory: (httpLink: HttpLink, router: Router) => {
        // Anexa o JWT (Bearer) em toda operação GraphQL.
        const auth = new ApolloLink((operation, forward) => {
          const token = lerToken();
          if (token) {
            operation.setContext({
              headers: { Authorization: `Bearer ${token}` },
            });
          }
          return forward(operation);
        });

        // Token expirado/ausente → limpa e manda para o login.
        const erro = onError(({ networkError }) => {
          const status = (networkError as { status?: number })?.status;
          if (status === 401) {
            localStorage.removeItem('eurofarma_raizes_token');
            router.navigate(['/login']);
          }
        });

        return {
          cache: new InMemoryCache(),
          link: ApolloLink.from([
            erro,
            auth,
            httpLink.create({ uri: environment.graphqlUri }),
          ]),
        };
      },
      deps: [HttpLink, Router],
    },
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000',
    }),
  ],
};
